// Shared WhatsApp constants. AARYA_WA_NUMBER is the E.164 digits-only form of
// the Meta WABA number registered for Aarya (matches META_WHATSAPP_PHONE_NUMBER_ID
// on the backend). Any user tapping a wa.me link built with this constant opens
// their WhatsApp app pre-filled with a message to Aarya - one Send tap and their
// number is marked opted-in via the /whatsapp/webhook inbound handler.
export const AARYA_WA_NUMBER = "919270295963";

// Build a wa.me URL with a pre-filled message. Contact opts in with a single tap.
// If `inviteToken` is provided, the backend webhook can match the exact invite
// regardless of which WhatsApp account (dual-SIM phones!) actually sends the
// message. This is critical because wa.me links open whichever WhatsApp is
// currently active on the phone - the user may have multiple accounts.
export function buildAaryaOptInLink(userName, inviteToken) {
  let base;
  if (inviteToken) {
    base = userName
      ? `Hi Aarya, please accept my Trust Circle invite from ${userName}. Invite-Token: ${inviteToken}`
      : `Hi Aarya, please accept my Trust Circle invite. Invite-Token: ${inviteToken}`;
  } else {
    base = userName
      ? `Hi Aarya, please switch me to WhatsApp for ${userName}'s Trust Circle alerts.`
      : "Hi Aarya, please activate WhatsApp for my Trust Circle alerts.";
  }
  return `https://wa.me/${AARYA_WA_NUMBER}?text=${encodeURIComponent(base)}`;
}

